var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 153,
    height: 32,
    viewBox: "0 0 153 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.4426 25.644C11.7098 24.528 14.5229 12.868 23.6948 10.876V6.29601C19.7119 6.88801 14.4945 9.28801 11.6329 13.516L11.4183 13.836L11.4426 9.20001H6.4762V25.628L11.4426 25.644Z",
    fill: "#003DA6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M35.9915 6.29601V10.876C26.8196 12.876 24.0025 24.528 23.7394 25.644H18.7527V15.052C20.8574 13.008 22.9703 12.368 23.7151 12.352V13.832L23.9296 13.516C26.7872 9.28801 32.0248 6.88801 35.9915 6.29601",
    fill: "#003DA6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M35.9914 12.352V25.644H31.0291V15.052C33.1298 13.008 35.2467 12.368 35.9914 12.352Z",
    fill: "#003DA6"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M44.8882 23.488V8.13202H51.3644L53.7929 18.532H53.8334L56.1689 8.13202H62.5398V23.488H58.9537V10.644L58.9132 10.6L55.4525 23.488H51.761L48.5229 10.492L48.4825 10.536V23.488H44.8882Z",
    fill: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M64.2722 23.488L70.1332 8.13202H75.1117L80.9524 23.488H76.322L75.3384 20.488H69.3236L68.3603 23.488H64.2722ZM74.3346 17.512L72.4484 11.132H72.3877L70.3639 17.512H74.3346Z",
    fill: "black"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M82.4702 8.13202H88.2057L93.164 19.576L93.2045 19.532V8.13202H96.8959V23.488H91.2293L86.2102 11.728H86.1697V23.488H82.4824L82.4702 8.13202Z",
    fill: "black"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M113.819 8.13202V17.852C113.779 22.128 110.48 23.808 106.752 23.808C103.024 23.808 99.7211 22.128 99.6807 17.852V8.13202H103.781V17.64C103.842 19.596 104.825 20.84 106.752 20.84C108.679 20.84 109.662 19.608 109.723 17.64V8.13202H113.819Z",
    fill: "black"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M126.933 8.13202H131.013L125.622 23.488H120.728L115.503 8.13202H120.032L123.372 19.256H123.412L126.933 8.13202Z",
    fill: "black"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M129.904 23.488L135.745 8.13202H140.744L146.585 23.488H141.954L140.97 20.488H134.968L134.005 23.488H129.904ZM139.967 17.512L138.08 11.132H138.02L135.996 17.512H139.967Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.02417e07d463779612c5fef85a01fcbe.svg";
export { ForwardRef as ReactComponent };